import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Typography,
  Box,
} from "@material-ui/core";
import { Warning as WarningIcon } from "@material-ui/icons";
import moment from "moment";
import { STUDENT_GUIDANCE } from "../../constants/selectOptions";

const getGuidanceTypeLabel = (value) => {
  const option = STUDENT_GUIDANCE.guidanceType.find((opt) => opt.value === value);
  return option ? option.title : value;
};

function DuplicateCheckModal({ open, handleClose, handleSelect, duplicateList }) {
  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center">
          <WarningIcon style={{ color: "#ff9800", marginRight: 8 }} />
          <Typography variant="h6">Phát hiện tiêu đề trùng lặp</Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" style={{ marginBottom: 16 }}>
          Hệ thống phát hiện các hướng dẫn NCKH sinh viên có tiêu đề tương tự. Vui lòng kiểm tra và chọn chỉnh sửa nếu
          đây là bản ghi đã tồn tại, hoặc bỏ qua để tiếp tục tạo mới.
        </Typography>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Tiêu đề</TableCell>
                {/* <TableCell>Loại hướng dẫn</TableCell> */}
                <TableCell>Ngày hoàn thành</TableCell>
                <TableCell align="center">Hành động</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {duplicateList.map((item, index) => (
                <TableRow key={index}>
                  <TableCell>{item?.title || "N/A"}</TableCell>
                  {/* <TableCell>{getGuidanceTypeLabel(item.studentGuidance?.guidanceType) || "N/A"}</TableCell> */}
                  <TableCell>
                    {item?.completionDate ? moment(item?.completionDate).format("DD/MM/YYYY") : "N/A"}
                  </TableCell>
                  <TableCell align="center">
                    <Button variant="outlined" color="primary" size="small" onClick={() => handleSelect(item)}>
                      Chỉnh sửa
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Box display="flex" justifyContent="flex-end" marginTop={2}>
          <Button onClick={handleClose} color="primary" variant="contained">
            Đóng
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default DuplicateCheckModal;

